import Stimp from "stimp/lib/index";

export class Header extends Stimp.DOMInteractModule {
  dom = {
    root: null,
    ddTrigger: {
      desktop: null,
      mobile: null,
    },
    ddMenu: null,
    mDdMenu: null,
  }

  constructor(app, name, initState = {}, depends = []) {
    super(app, name, initState = {
      isSticky: false,
      isMenuOpen: false,
    }, depends);

    this.onAfterDomInit(() => {
      $([this.dom.ddTrigger.desktop, this.dom.ddTrigger.mobile]).on('click', () => {
        this.handleClickTrigger();
      });

      this.onUpdateIsMenuOpen(false);

      window.addEventListener('scroll', () => this.handleCheckIsSticky());
      window.addEventListener('resize', () => this.handleCheckIsSticky());
      this.handleCheckIsSticky();

      document.addEventListener('keydown', (e) => {
        if (e.keyCode === 27) {
          this.setState({
            isMenuOpen: false,
          });
        }
      });

      if (window.innerWidth > 768) {
        $(document).on('click',(e) => {
          if (e.target !== this.dom.ddTrigger.desktop) {
            if (jQuery(e.target).closest('.header__dd-menu').length) return;
            setTimeout(() => {
              if (!this.getState().isMenuOpen) return;
              this.setState({
                isMenuOpen: false,
              });
            }, 0);
          }
        });
      }
    });
  }

  handleClickTrigger() {
    this.setState({
      isMenuOpen: !this.getState().isMenuOpen,
    });
  }

  handleCheckIsSticky() {
    this.setState({
      isSticky: window.scrollY > 0
    });
  }

  onUpdateIsSticky(isSticky, prevIsSticky) {
    if (isSticky) {
      $(this.dom.root).addClass('sticky');
    } else {
      $(this.dom.root).removeClass('sticky');
    }
  }


  onUpdateIsMenuOpen(isMenuOpen, prevIsMenuOpen) {
    if (isMenuOpen) {
      $(this.dom.root).addClass('menu-show');
      $(this.dom.ddMenu).find('a').attr('tabindex', null);
    } else {
      $(this.dom.root).removeClass('menu-show');
      $(this.dom.ddMenu).find('a').attr('tabindex', -1);
    }
  }
}